import React, { Component } from 'react'
import _ from 'lodash'

import { updateModuleData, applyUnitsToProps } from 'helpers/specHelpers'
import CommonSpec from 'containers/Project/CommonSpec/index'

class SystemSpec extends Component {
  render() {
    const {
      moduleData,
      isModifiedPage,
      curFilter,
      ModuleHeader,
    } = this.props

    return (
      <CommonSpec
        moduleName='system'
        moduleData={moduleData}
        isModifiedPage={isModifiedPage}
        curFilter={curFilter}
        ModuleHeader={ModuleHeader}
      />
    )
  }
}

export default SystemSpec
